module.exports = __webpack_public_path__ + "static/media/Babysitter.531390e5.jpg";